import {
  AppWindow,
  Archive,
  ArrowLeft,
  ArrowRight,
  Bot,
  Blocks,
  CalendarDays,
  Car,
  ChevronLeft,
  ChevronRight,
  ExternalLink,
  Factory,
  FileText,
  Gamepad2,
  Hammer,
  Inbox,
  Link as LinkIcon,
  MessageSquare,
  Newspaper,
  Package,
  Pickaxe,
  Puzzle,
  Rocket,
  Send,
  Train,
  type LucideIcon,
} from "lucide-react";
import { cn } from "cn";

/**
 * Ограниченный словарь иконок lucide-react по имени.
 *
 * Имена иконок хранятся в контенте (`content/ru.ts`). Чтобы не тянуть
 * в бандл весь набор lucide (особенно в клиентские компоненты), здесь
 * перечислены только реально используемые иконки. Неизвестное имя → Package.
 */
const ICONS: Record<string, LucideIcon> = {
  Gamepad2,
  AppWindow,
  Puzzle,
  Pickaxe,
  Blocks,
  Hammer,
  Factory,
  Car,
  MessageSquare,
  Bot,
  Send,
  Rocket,
  Train,
  Package,
  Inbox,
  Newspaper,
  FileText,
  Archive,
  CalendarDays,
  ArrowLeft,
  ArrowRight,
  ChevronLeft,
  ChevronRight,
  ExternalLink,
  Link: LinkIcon,
};

/**
 * Иконка по имени из контента. Работает и на сервере, и в клиенте.
 * Принимает имя с суффиксом «Icon» или без него.
 */
export function Icon({
  name,
  className,
  "aria-hidden": ariaHidden = true,
}: {
  name: string;
  className?: string;
  "aria-hidden"?: boolean;
}) {
  const cleaned = name.trim().replace(/Icon$/, "");
  const Component = ICONS[cleaned] ?? Package;
  return <Component className={cn("size-5 shrink-0", className)} aria-hidden={ariaHidden} />;
}
